import React from "react";
import DesktopDatePicker from "./DesktopDatePicker";
import classNames from "classnames";
import MobileDatePicker from "./MobileDatePicker";
import { isSmallScreen } from "utils/constants/onboardingStep";

const MyCalendar = ({
  handleDatePicker,
  selectedValue,
  setModal,
  highlightToday,
  disableMonthYearPicker,
  isMultiple,
  showButtons,
  handleMultipleDates,
  value,
  multipleValues,
  isRendered,
  isOwnDates,
  showModal,
}) => {
  const handleShowModal = (value) => {
    setModal(value);
  };

  return (
    <>
      <div
        className={classNames({
          flex: isOwnDates,
          "hidden screen-lg:flex screen-md:flex": !isOwnDates,
        })}
      >
        <DesktopDatePicker
          highlightToday={highlightToday}
          disableMonthYearPicker={disableMonthYearPicker}
          isMultiple={isMultiple}
          showButtons={showButtons}
          handleMultipleDates={handleMultipleDates}
          handleDatePicker={handleDatePicker}
          value={value}
          multipleValues={multipleValues}
          selectedValue={selectedValue}
          isRendered={isRendered}
        />
      </div>

      {isSmallScreen && !isOwnDates && (
        <div className="w-full screen-lg:hidden screen-md:hidden screen-sm:flex">
          <div className="flex justify-center items-center">
            <MobileDatePicker
              openModal={showModal}
              disableMonthYearPicker={disableMonthYearPicker}
              showButtons={showButtons}
              handleDatePicker={handleDatePicker}
              selectedValue={selectedValue}
              setOpenModal={setModal}
              isRendered={isRendered}
              setShow={handleShowModal}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default MyCalendar;
